import { isUUID, omit } from 'external/lodash'
import { paramsHook} from 'external/deep-diff'
import { userService } from 'services/user.service'
import { isLoggedInAndInRoute } from 'utilities/navigate'
import { packageService } from 'services/package.service'
import { clientService } from 'services/client.service'
import { paymentService } from 'services/payment.service'
import { isEmpty } from 'utilities/text'

const hooks =  [
  {paths: paramsHook('pageName'), resolves: [fetchHome]},
  {paths: [...paramsHook('pageName', 'role', 'userId'), 'users/refreshes/'], resolves: fetchUsers},
  {paths: [...paramsHook('pageName', 'role', 'userId')], resolves: fetchUserPackageDetails},
  {paths: [...paramsHook('pageName'), 'payments/refreshes'], resolves: fetchPayments},
  {paths: [...paramsHook('pageName', '?subscription'), 'paymentHistory/refreshes'], resolves: fetchPaymentHistory},
  {paths: [...paramsHook('pageName')], resolves: fetchProfile}
]

export {hooks as default}

export async function fetchHome({update, state}, {contexts}) {
  const id = isLoggedInAndInRoute('home', {state, contexts})
  if (!isUUID(id)) return
  const home = await userService.getHome(id)
  update({homeData: {$set: home.data}})

}

export async function fetchUsers({update, state}, {contexts}) {
  const id = isLoggedInAndInRoute('users', {state, contexts})
  if (!isUUID(id)) return
  const {role} = state.props.params
  const validRole = ['student', 'tutor'].indexOf(role) >= 0
  if (!validRole) return
  const response = await userService.getUsersByRole(role, id, true)
  update({ users: {$startLoading: {}}})
  const users = response.data.data || []
  update({ users: {$updateLoadableList: users}})
}

export async function fetchUserPackageDetails({update, state}, {contexts}) {
  const clientId = isLoggedInAndInRoute('userPackages', {state, contexts})
  if (!isUUID(clientId)) return
  const {role, userId} = state.props.params
  const validRole = ['student', 'tutor'].indexOf(role) >= 0
  if (!validRole) return
  if (!isUUID(userId)) return
  const response = await userService.packages(userId, clientId)
  update({ userPackageDetailsProfile: {$set: false}, userPackageDetails: {$startLoading: {}}})
  const {packages, profile} = response.data || {packages: [], profile: {}}
  update({ userPackageDetailsProfile: {$set: profile}, userPackageDetails: {$updateLoadableList: packages}})
}

export async function fetchPayments({update, state}, {contexts}) {
  const clientId = isLoggedInAndInRoute('payment', {state, contexts})
  if (!isUUID(clientId)) return
  const response = await packageService.getPackageByClientId(clientId)
  update({ payments: {$startLoading: {}}})
  const payments = response.data.data || []
  update({ payments: {$updateLoadableList: payments}})
}

export async function fetchPaymentHistory({update, state}, {contexts}) {
  const clientId = isLoggedInAndInRoute('history', {state, contexts})
  if (!isUUID(clientId)) return
  const {subscription: subscriptionId} = state.props.query
  if (isEmpty(subscriptionId)) return
  const response = await paymentService.getPaymentHistory(subscriptionId);
  update({ paymentHistorySubscription: {$set: {}}, paymentHistory: {$startLoading: {}}})
  const subscription = response.data.data && omit(response.data.data,['invoices']) || {}
  const payments = response.data.data && response.data.data.invoices || []
  update({ paymentHistorySubscription: {$set: subscription}, paymentHistory: {$updateLoadableList: payments}})
}

export async function fetchProfile({update, state}, {contexts}) {
  const clientId = isLoggedInAndInRoute('profile', {state, contexts})
  if (!isUUID(clientId)) return
  const response = await clientService.getProfile(clientId)
  const {data: {data: profile}} = response
  update({ userProfile: {$set: profile}})
}